// src/beta/components/slides/DividerSlide.tsx
import type { V1Slide } from '@/beta/types/story';

interface Props { slide: V1Slide; }

/** Divider slide — centered red rule with optional heading above. Used to
 *  mark chapter transitions inside a story. */
export function DividerSlide({ slide }: Props) {
  const heading = slide.block.heading ?? undefined;

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        background: 'var(--vm-dark)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'var(--vm-s-6)',
        color: 'var(--vm-warm-white)',
      }}
    >
      {heading && (
        <h2
          className="vm-fade-up-blur"
          style={{
            fontFamily: 'var(--vm-font-heading)',
            fontSize: 28,
            letterSpacing: '0.4em',
            textTransform: 'uppercase',
            margin: 0,
          }}
        >
          {heading}
        </h2>
      )}

      <span
        data-testid="divider-rule"
        style={{ width: 120, height: 1, background: 'var(--vm-red)' }}
      />
    </div>
  );
}
